import { createRouter, createWebHistory } from 'vue-router'
import MenuLayout from '@/layout/MenuLayout.vue'
import ViewLayout from '@/layout/ViewLayout.vue'
import HomeView from '@/views/HomeView.vue'
import LoginPage from "@/views/UserLogin.vue"
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'viewLayout',
      redirect: '/login',
      component: ViewLayout,
      children: [
        {
          path: 'login',
          name: 'login',
          component: LoginPage ,
        },
      ],
    },
    {
      path: '/',
      name: 'menuLayout',
      component: MenuLayout,
      children: [
        {
          path: 'home',
          name: 'home',
          component: HomeView,
        },
      ],
    },
  ],
})

export default router
